export default "__VITE_ASSET__ChxfGN85__"